export enum TIdentObjectTypeEnum {
  User = 'USER',
  UserRole = 'USER_ROLE',
  Tenant = 'TENANT',
}

export enum TIdentOperationTypeEnum {
  IdentObjectCreated = 'IDENT_OBJECT_CREATED',
  IdentObjectUpdated = 'IDENT_OBJECT_UPDATED',
  IdentObjectDeleted = 'IDENT_OBJECT_DELETED',
  IdentObjectLinked = 'IDENT_OBJECT_LINKED',
  IdentObjectUnlinked = 'IDENT_OBJECT_UNLINKED',
  IdentObjectLinkUpdated = 'IDENT_OBJECT_LINK_UPDATED',
  IdentTenantSwitched = 'IDENT_TENANT_SWITCHED',
}
